<script lang="ts">
	import PopperIcon from "../SVG/Popper.svelte";
	import { createPopperActions } from "svelte-popperjs";

	export let fill = "#3c68d6";
	export let description = "";

	const [popperRef, popperContent] = createPopperActions({
		placement: "bottom",
		strategy: "fixed",
	});

	const extraOpts = {
		modifiers: [{ name: "offset", options: { offset: [0, 11] } }],
	};

	let hover = false;
</script>

<div
	use:popperRef
	class="container"
	on:mouseenter={() => (hover = true)}
	on:mouseleave={() => (hover = false)}
>
	<PopperIcon fill={fill} />
	{#if hover}
		<div class="description" use:popperContent={extraOpts}>
			{@html description}
		</div>
	{/if}
</div>

<style lang="scss">
	@import "../variables.scss";
	div {
		box-sizing: border-box;
	}
	.container {
		width: 100%;
		height: 100%;

		.description {
			width: 225px;
			// 아래 height 건들면 mbr 관리쪽 팝업 height가 채워지지않음
			/* height: 57px; */
			max-width: 300px;
			padding: 10px;
			border-radius: 5px;
			background-color: #e6e7ed;
			word-break: break-all;
			color: inherit;
			font-size: 14px;
			font-weight: inherit;
			line-height: 20px;
			letter-spacing: -0.56px;
			box-shadow: 0 0 6px 0 rgba(0, 0, 0, 0.1);
			z-index: 99;
		}
	}
	@include DesktopSize {

	}
</style>
